import { useState } from 'react'
import './Pages.css'
import './Contact.css'

const hero = {
    image: '/images/group/_DSC6809.JPG',
    mobileImage: '/images/group/_DSC6809.JPG',
    imagePosition: 'center center',
}

function Contact() {
    const [showEmail, setShowEmail] = useState(false);
    const user = 'kazokuquartet';
    const domain = 'gmail.com'
    const email = user + '@' + domain;

    return (
        <>
        <section className="contact-hero">
            <picture>
                <source media="(max-width: 768px)" srcSet={hero.mobileImage} />
                <img
                    src={hero.image}
                    alt="Kazoku Quartet"
                    className="contact-hero-img"
                    style={hero.imagePosition ? { objectPosition: hero.imagePosition } : undefined}
                />
            </picture>
            <div className="contact-hero-overlay">
                <h1 className="contact-hero-title">Contact</h1>
                <div className="contact-scroll-hint" aria-hidden="true">&#8595;</div>
            </div>
        </section>
        <div className="page">
            <p>For inquiries, please{' '}
                <span
                className="email-link"
                onClick={()=> setShowEmail(true)}
                onKeyDown={(e)=> { if (e.key === 'Enter') setShowEmail(true); }}
                role="button"
                tabIndex={0}>
                    send us an email
                </span>!
            </p>
            {showEmail && (
                <p className='email-reveal'>
                    <a href={'mailto:' + email}>{email}</a>
                </p>
            )}
            <p className="contact-media-pack">
                <a href="/media/kazoku-media-pack.zip" download>Click here</a> to download our media pack
            </p>
        </div>
        </>
    );
}

export default Contact; 